import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a0d] py-12 px-4" data-id="element-319">
      <div className="max-w-5xl mx-auto" data-id="element-320">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-321">
          <div data-id="element-322">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-323">
              +500
            </div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-324">
              profes confían
            </div>
          </div>
          <div data-id="element-325">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-326">
              6+6
            </div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-327">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-328">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-329">
              4.9/5
            </div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-330">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-331">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-332">🇦🇷</div>
            <div className="text-[#00C853] text-sm font-semibold mt-1" data-id="element-333">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-334">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-335">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-336">
              MG
            </div>
            <div data-id="element-337">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-338">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-339">
                "Organicé todo el año de Baby Fútbol en una tarde. Nunca más
                llegué sin material al club. Las planillas me ahorran horas cada
                semana."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-340">
                — Marcos G., Córdoba | DT Baby Fútbol Club de Barrio
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-341">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-342">
              LP
            </div>
            <div data-id="element-343">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-344">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-345">
                "Las sesiones están perfectamente pensadas para el pibe
                argentino de club de barrio. El tomo de táctica es el hit del
                vestuario. Vale cada peso."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-346">
                — Laura P., Rosario | Profe de Ed. Física | Escuelita de Fútbol
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00C853]/20 rounded-xl p-4" data-id="element-347">
            <div className="w-10 h-10 rounded-full bg-[#00C853]/20 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-348">
              RM
            </div>
            <div data-id="element-349">
              <div className="text-[#00C853] text-xs mb-1" data-id="element-350">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-351">
                "Nunca más llegué sin plan al club. Mis clases de 10 años con
                táctica colectiva por fin funcionan. El Manual del DT Ganador
                fue el plus que me faltaba para ganar desde el banco."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-352">
                — Roberto M., Buenos Aires | DT Baby Fútbol + Escuelita
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}